<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Банеры</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <AdsPlacesTable
                            class="mt-4"
                            :data.sync="data"
                            @select="(id) => $router.push(`ads-places/${id}`)"
                        />

                        <CPagination
                            v-if="total > 1"
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="total"
                            align="center"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`ads-places/create`)"
                    >Создать</CButton
                    >
                    <CButton
                        class="ml-4"
                        color="info"
                        @click="reorder"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import AdsPlacesTable from '@/components/ads-places/AdsPlacesTable';
    import { ITEMS_PER_PAGE } from '@/utils/views';

    export default {
        name: 'AdsPlacesList',

        components: {
            AdsPlacesTable,
        },

        data() {
            return {
                loading: true,
                data: [],
                total: 0,
                itemsPerPage: ITEMS_PER_PAGE,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const params = {
                    page: this.activePage,
                    pageSize: this.itemsPerPage,
                };
                const response = await this.axios.get('/ads-places', { params });
                this.data = response.data.results;
                this.total = Math.ceil(response.data.total / this.itemsPerPage);
            },
            async reorder() {
                try {
                    const payload = {
                        reorder: this.data.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title }))
                    };
                    await this.axios.post('/ads-places/reorder', payload);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения расположения.');
                }
            }
        },
    };
</script>
